<template>
    <div style="position: relative">
        <c-card-iterator
            :items          = "filteredItems"
            :label          = "$t('todo.bounced.title')"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "76"
            :min-height     = "topHeight"
            :filter         = "match"
            :filter-height  = "72"
            :height         = "height"
            @search         = "onSearch"
        >
            <template v-slot:card="{ item }">
                <p-inc-bounced-mail-card
                    :mail   = "item"
                    @site   = "onSite"
                    @mail   = "onMail"
                />
            </template>
        </c-card-iterator>

        <div v-if="!items || items.length === 0" class="lm-border empty-todos">
            <v-icon color="success" size="30">mdi-check-circle</v-icon>
        </div>
    </div>
</template>

<script>

import CCardIterator      from "@/modules/core/components/utils/CCardIterator.vue";
import Core               from "@/modules/core/service/Core";
import PIncBouncedMailCard from "@/modules/inc/todos/components/private/PIncBouncedMailCard.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PIncBouncedMailIterator",

    components: {
        PIncBouncedMailCard,
        CCardIterator
    },

    props: {
        height: {

        },

        topHeight: {

        },
    },

    data: () => ({
        loading      : false,
        search       : null,
        filteredItems: null,
        items        : null,
    }),

    mounted () {
        this.initialize();
    },

    methods: {
        onSearch (search) {
            this.search = search;
            this.doFilter();
        },

        onSite (item) {
            this.$emit("site", item.unitId);
        },

        onMail (mail) {
            this.$emit("mail", mail);
        },

        initialize () {
            Inc.todo.bounce.mails().then (data => {
                this.items = data;
                this.doFilter();
            })
        },

        doFilter () {
            if (!this.items) {
                return;
            }

            this.filteredItems = this.items.filter(i => this.match(i));
        },

        match (item) {
            console.log("TODO", item)
            return true;
        },

        dateAsString (value) {
            return Core.format.date.display(value)
        },
    }
}
</script>

<style scoped>

</style>